import React, { useEffect } from 'react'
// import Methodik from '../methodik'
import './styles.scss'
import '../../../static/direktwahlfrage/style.css'

function DeWidgets(props) {
  // let params = new URL(window.location).searchParams
  // let type = params.get('type')

  useEffect(() => {
    const script = document.createElement('script')

    script.src = 'https://dpa-infocom.s3-eu-west-1.amazonaws.com/js/dpa.js'
    script.async = true

    document.body.appendChild(script)
  })

  let subtitleClass = false

  if (props.subtitle !== '') {
    subtitleClass = true
  }

  if (props.chartType === 'umfrageverlauf') {
    return (
      <div className='dpaChart'>
        <div className='widgetWrapper'>
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='chart'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/bundestagswahl-resultate/umfrageverlauf/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (props.chartType === 'direktwahlfrage') {
    return (
      <div className='dpaChart'>
        <div className='widgetWrapper'>
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='ranking'
            data-max-parties='all'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/bundestagswahl-resultate/direktwahlfrage/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (props.chartType === 'stimmenanteile') {
    return (
      <div className='dpaChart'>
        <div className='widgetWrapper'>
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='bars'
            data-max-parties='all'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/bundestagswahl-resultate/stimmanteile/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (props.chartType === 'sitzverteilung') {
    return (
      <div className='dpaChart'>
        <div className='widgetWrapper'>
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='seats'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/bundestagswahl-resultate/sitzverteilung/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (props.chartType === 'stimmenanteileQuer') {
    return (
      <div className='dpaChart'>
        <div className='widgetWrapper'>
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='barsList'
            data-max-parties='all'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/bundestagswahl-resultate/stimmenanteileQuer/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (props.chartType === 'koalitionsrechner') {
    return (
      <div className='dpaChart'>
        <div className='widgetWrapper'>
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='coalition'
            data-hide-coalitions='true'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/bundestagswahl-resultate/koalitionsrechner/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (props.chartType === 'wahlkreisergebnisse') {
    return (
      <div className='dpaChart'>
        <div className='widgetWrapper'>
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='votingAreas'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/bundestagswahl-resultate/wahlkreisergebnisse/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (props.chartType === 'waehlerwanderung') {
    return (
      <div className='dpaChart'>
        <div className='widgetWrapper'>
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='voterMigration'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/bundestagswahl-resultate/waehlerwanderung/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (props.chartType === 'mehrheiten-in-den-wahlkreisen') {
    return (
      <div className='dpaChart'>
        <div className='widgetWrapper'>
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='areaTotal'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/bundestagswahl-resultate/mehrheiten-in-den-wahlkreisen/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  if (props.chartType === 'parteihochburgen') {
    return (
      <div className='dpaChart'>
        <div className='widgetWrapper'>
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='bw_de'
            data-language='de'
            data-standalone='partyStrength'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2021/bundestagswahl-resultate/parteihochburgen/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/bundestagswahl/aws/tamedia/html/index.html'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/bw_de/'
          />
        </div>
      </div>
    )
  }

  return false
}

export { DeWidgets }
